import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { AuthService } from '@pg-app/core/services/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoleNames } from '@pg-app/core/services/roles/RoleNames';
import { MatDialog } from '@angular/material/dialog';
import { CheckAccountComponent } from '@pg-app/client/client-dashboard/dialogs/check-account/check-account.component';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';
import { RolesService } from '@pg-app/core/services/roles/role.servirce';
import { ManageUserService } from '@pg-app/partner/manage-user/services/manage-user.service';
@Component({
  selector: 'np-nav',
  templateUrl: './base-nav.component.html',
  styleUrls: ['../client-nav/client-nav.component.scss']
})
export class BaseNavComponent {
  public showHideMenu = true;
  public showHideSubMenu = true;
  public mobile: boolean;
  @ViewChild('menu', { static: true })
  menu: ElementRef;
  userInfo = {
    fullName: '',
    firstName: '',
    accountNumber: '',
    accountName: ''
  };
  isPartnerAdmin = false;
  partnerAdmin;
  notVerify = false;
  VIEW_DASHBOARD = RoleNames.VIEW_DASHBOARD;
  SEND_REFERRAL = RoleNames.SEND_REFERRAL;
  MANAGE_USERS = RoleNames.MANAGE_USERS;
  VIEW_REPORT = RoleNames.VIEW_REPORT;
  viewReportState = false;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private registrationStep2Service: RegistrationStep2Service,
    private dialog: MatDialog,
    private roleService: RolesService,
  ) {
    this.checkAccount();
  }

  @HostListener('click', ['$event'])
  public lostFocus(event) {
    if (
      (event.target as HTMLElement).matches('.menu-user,.target-click') ||
      this.menu.nativeElement.contains(event.target)
    ) {
      return;
    }
    this.showHideMenu = true;

    if (window.screen.width < 1000) {
      this.mobile = true;
    }
  }

  showMenu() {
    this.showHideMenu = !this.showHideMenu;
  }

  logout() {
    this.authService.logout();
  }

  hideSubMenu() {
    this.showHideSubMenu = true;
  }

  hideMenu() {
    this.showHideMenu = true;
  }

  showHideViewReport() {
    this.viewReportState = !this.viewReportState;
  }

  checkAccount() {
    this.roleService.getRolesfromAPI().subscribe(roles => {
      roles.forEach(role => {
        if (role.name === RoleNames.MANAGE_USERS){
          this.partnerAdmin = role;
        }
      });
    });

    this.registrationStep2Service.getAccountType().subscribe(
      data => {
        this.userInfo = {
          fullName: data.fullName,
          firstName: data.fullName.split(' ')[0],
          accountNumber: data.accountNumber,
          accountName: data.accountName ?? data.fullName
        };

        if (!data.isStep2Completed) {
          this.notVerify = true;
          this.dialog.open(CommonDialogComponent, {
            disableClose: true,
            data: {
              title: 'Please complete your account registration.',
              dialogType: 1,
              routingUrl: 'partner/register/step-2'
            }
          });
        } else if (!data.accountNumber) {
          this.notVerify = true;
          const message =
            'We are reviewing your application and we will email you when it is complete.<br> Please log back in after receiving the email';
          this.dialog.open(CheckAccountComponent, {
            disableClose: true,
            data: {
              hasButton: false,
              message: message,
            }
          });
        }
      },
    );
  }
}
